define('plugin/multiple-booking/MultipleBookingPlugin',['require','collection/BookingCollection','lib/plugin/PluginAbstract','lib/view/BookingUrlBuilder','plugin/multiple-booking/view/MultipleBookingButtonView','plugin/multiple-booking/view/MultipleBookingListView','plugin/multiple-booking/model/MultipleBookingBatchModel','lib/plugin/PluginBroker','plugin/multiple-booking/model/MultipleBookingCartModel'],function (require) {

    var BookingCollection = require('collection/BookingCollection');
	var PluginAbstract = require('lib/plugin/PluginAbstract');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');
    var MultipleBookingButtonView = require('plugin/multiple-booking/view/MultipleBookingButtonView');
    var MultipleBookingListView = require('plugin/multiple-booking/view/MultipleBookingListView');
    var MultipleBookingBatchModel = require('plugin/multiple-booking/model/MultipleBookingBatchModel');
    var PluginBroker = require('lib/plugin/PluginBroker');
    var MultipleBookingCartModel = require('plugin/multiple-booking/model/MultipleBookingCartModel');

	return PluginAbstract.extend({

        _detailsStep: null,
	    _detailsStepView: null,
        _multipleBookingDetailsRegions: {
            'multipleBookingButton': '#sb_multiple_booking_button_container',
            'multipleBookingList': '#sb_multiple_booking_list_container'
        },
        _multipleBookingModulesRegions: {
            // 'multipleBookingCartModule': '#sb_multiple_book_cart'
        },
        _serviceCollection: null,
        _bookingCollection: null,
        _batchModel: null,
        _confirmBatch: true,
        _requestModel: null,
        _cartRegion: null,

        initialize: function () {
            this._bookingCollection = new BookingCollection();
            this.initCartModel();
        },

        initCartModel: function () {
            this._cartModel = new MultipleBookingCartModel({
                items: this._bookingCollection
            });
            this.listenTo(this._cartModel, 'after:checkout', this.afterCartCheckout);
            var _this = this;
            this._cartModel.load().then(function(){
                if (_this._cartModel.get('batch_model')) {
                    _this._batchModel = _this._cartModel.get('batch_model');
                    _this._requestModel = _this._cartModel.get('request_model');
                    // fixing comnfirmation after reload
                    _this._stepManager.getBookingModel().set('batch_model', _this._batchModel);

                    if (_this._requestModel) {
                        // _this._bookingCollection.reset(_this._requestModel.get('bookings').models);
                        PluginBroker.getInstance().perform('multipleBookingUpdated', [_this._bookingCollection.length > 0]);
                    }
                }
            });
            this.listenTo(this._cartModel, 'checkout', this.saveMultipleBooking);

            this.listenTo(this._bookingCollection, 'update reset', this._checkRemoveBatch);
        },

        _checkRemoveBatch: function () {
            if (!this._bookingCollection.length) {
                this._batchModel = null;
                this._requestModel = null;
                this._cartModel.set('batch_model', null);
                this._cartModel.set('request_model', null);
                this._cartModel.save();

                PluginBroker.getInstance().perform('multipleBookingUpdated', [false]);
            }
        },

        getCollection: function () {
            return this._bookingCollection;
        },

        /**
         * Initialize multiple booking collection, subscribe to events to show multiple booking views
         */
        initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:details', this.addMultipleBookingViews);
            this.listenTo(this._stepManager.getBookingModel(), 'change:service_id', this.updateMultipleBookingViewsStateOnBookingChange);
            this.listenTo(this._stepManager.getBookingModel(), 'invalid', this.resetConfirmFlag);

            this.listenTo(this._stepManager, 'step:init:service', this.addServiceFilter);

            this.getOption('app').module.cart.setStepManager(this._stepManager);
        },

        resetConfirmFlag: function () {
            this._confirmBatch = true;
        },

        initModules: function (layout) {
            if (!this._cartModuleAdded) {
                var cartRegion = this._cartRegion = this.getOption('app').module.cart.addItem(this._cartModel, 'multipleBooking');
                this._cartModuleAdded = true;
            
                var bookingsListView = new MultipleBookingListView({
                    'collection': this._bookingCollection,
                    'mode': 'cart'
                });
                setTimeout(function(){
                    cartRegion.show(bookingsListView);
                }, 500); //TODO fix this hack - listen to when cart view id rendered???
            }

            // _.each(this._multipleBookingModulesRegions, function (selector, multipleRegion) {
            //     layout.addRegion(multipleRegion, selector);
            // });

            // var bookingsList = new MultipleBookingListView({
            //     'collection': this._bookingCollection,
            //     'mode': 'popup'
            // });
            // layout.multipleBookingCartModule.show(bookingsList);

            // this.listenTo(bookingsList, 'submit', this.saveMultipleBooking);
        },

        /**
         * Before show details step view we add multiple booking regions and views
         *
         * @param DetailsStep step
         * @param DetailsView view
         * @param Marionette.Region region
         */
        addMultipleBookingViews: function (step, view, region) {
            this._detailsStep = step;
            this._detailsStepView = view;
            _.each(this._multipleBookingDetailsRegions, function (selector, multipleRegion) {
                view.addRegion(multipleRegion, selector);
            });

            this.updateMultipleBookingViewsState();
        },

        /**
         * Updates multiple booking views and add to regions if it is possible. Subscribes to child events
         */
        updateMultipleBookingViewsState: function () {
            if (!this.isMultipleBookingAllowed()) {
                return;
            }
            var btnView = new MultipleBookingButtonView({
                bookingModel: this._stepManager.getBookingModel()
            });
            this._detailsStepView.multipleBookingButton.show(btnView);

            this._detailsStepView.multipleBookingList.show(new MultipleBookingListView({
                collection: this._bookingCollection,
                bookingModel: this._stepManager.getBookingModel()
            }));

            this.listenTo(btnView, 'submit', this.saveBooking);
        },

        /**
         * Updates multiple booking views after booking model is changed
         */
        updateMultipleBookingViewsStateOnBookingChange: function () {
            if (this._detailsStepView && this._detailsStepView.multipleBookingButton) {
                this.updateMultipleBookingViewsState();
            }
        },

        /**
         * Checks if multiple booking is allowed
         *
         * @return Boolean
         */
        isMultipleBookingAllowed: function () {
            var result = false;

            var serviceId = this._stepManager.getBookingModel().get('service_id');
            if (this._serviceCollection && this._serviceCollection.get(serviceId)) {
                var service = this._serviceCollection.get(serviceId);
                var count = this._stepManager.getBookingModel().get('count');
                if (!parseInt(service.get('is_recurring')) && (! count || parseInt(count) === 1)) { 
                    result = true;
                }
            }

            return result;
        },

        /**
         * On user click "book and add more" we creates batch (if it does not exists).
         * set this._confirmBatch = false (to not send notifications and back user to booking page after booking saved)
         * this._confirmBatch will be passed to server in BookingServerRequestModel
         * And start booking process.
         */
        saveBooking: function () {
            this._confirmBatch = false;

            if (!this._batchModel) {
                this._batchModel = new MultipleBookingBatchModel();
                this._batchModel.save({}, {'success': _.bind(function (model) {
                    this._cartModel.set('batch_model', model);
                    this.performSaveBooking();
                }, this)});

                this._stepManager.getBookingModel().set('batch_model', this._batchModel);
            } else {
                this.performSaveBooking();
            }
        },

        /**
         * On user click "book now" from popup we confirm the batch and redirects user to payment or result page.
         */
        saveMultipleBooking: function () {
            this._batchModel.set({
                'is_closed': true,
                'request_booking_model': this._requestModel,
                'products': this._cartModel.get('products')
            });
            this._batchModel.save({}, {'success': _.bind(function (model) {
                PluginBroker.getInstance().perform('finishBooking', [model.get('request_booking_model')]);

                this._stepManager.bookingDone(
                    model.get('request_booking_model')
                );

                this.getOption('app').module.cart.afterCheckout();
            }, this)});
        },

        /**
         * Starts booking process
         */
        performSaveBooking: function () {
            this._detailsStep.saveBooking();
        },

        /**
         * Before send data to server if batch exists we
         * set confirm: this._confirmBatch
         * Set batch_id to link bookings to single batch
         *
         * @param BookingServerRequestModel requestModel
         */
        beforeSaveBooking: function (requestModel) {
            if (this._batchModel) {
                // fixing comnfirmation after reload
                this._stepManager.getBookingModel().set('batch_model', this._batchModel);
                requestModel.set({
                    'batch_id': this._batchModel.get('id'),
                    'confirm': this._confirmBatch
                });
            }
        },

        /**
         * After save booking reset this._confirmBatch flag. In case booking/batch was not confirmed return user to booking page
         * Reset multiple booking collection to show bookings
         *
         * @param BookingServerRequestModel requestModel
         */
        afterSaveBooking: function (requestModel) {
            this._requestModel = requestModel;
            this._confirmBatch = true;
            this._bookingCollection.reset(requestModel.get('bookings').models);
            this._cartModel.set('request_model', requestModel);
            this._cartModel.save();

            // console.log(this._bookingCollection.toJSON());

            if (!requestModel.get('confirm')) {
                Backbone.history.navigate(
                    BookingUrlBuilder.getInstance().buildUrl('first_booking_step'), {trigger: true}
                );
            }
        },

        /**
         * Release data after finish booking process
         *
         * @param BookingServerRequestModel requestModel
         */
        finishBooking: function (requestModel) {
            this._stepManager.getBookingModel().set('batch_model', null);

            this._batchModel = null;
            this._confirmBatch = true;
            this._bookingCollection.reset();
            this._cartModel.save();
        },

        /**
         * Adds filter and comparator to services collection
         *
         * @param BaseStep step
         * @param FilterableCollection collection
         */
        addServiceFilter: function (step, collection) {
            this._serviceCollection = collection;

            // this is probably not the proper place, but only here we get service collection
            this.listenTo(this._serviceCollection, 'sync', function() {
                if (this._detailsStepView && this._detailsStepView.multipleBookingButton) {
                    this.updateMultipleBookingViewsState();
                }
            });

            this._serviceCollection.addFilter(_.bind(this.serviceFilter, this));
        },

        /**
         * Filters service model
         *
         * @param Backbone.Model
         * @return Boolean
         */
        serviceFilter: function (model) {
            if (this._batchModel && parseInt(model.get('is_recurring'))) {
                return false;
            }
            return true;
        },

        afterCartCheckout: function (data) {
            if (this._cartModel) {
                this._cartModel.clear();
            }
        },

	});
	
});
